import { Quaternion, TransformNode, Vector3 } from "babylonjs";

function getRotation(pos: Vector3, lookAt: Vector3): Vector3 {
  const node = new TransformNode("TempNode");

  node.position = pos;
  node.lookAt(lookAt);

  const result: Vector3 = node.rotation.clone();
  node.dispose();

  return result;
}

function stringContainsArrayElement(str: string, arr: string[]): boolean {
  let result = false;

  arr.forEach(ele => {
    if (str.indexOf(ele) > -1) {
      result = true;
    }
  });

  return result;
}

function trimImage(img: any) {
  return new Promise((resolve, reject) => {
    const image = new Image();
    image.src = img;

    image.onload = function() {
      const width = image.width;
      const height = image.height;

      const canvas = document.createElement("canvas");
      const copy: any = canvas.getContext("2d");
      canvas.width = width;
      canvas.height = height;
      copy.drawImage(image, 0, 0);

      const pixels = copy.getImageData(0, 0, width, height);
      const l = pixels.data.length;
      let i;
      const bound = {
        top: -1,
        left: -1,
        right: -1,
        bottom: -1
      };
      let x;
      let y;

      // Iterate over every pixel to find the highest
      // and where it ends on every axis ()
      for (i = 0; i < l; i += 4) {
        if (pixels.data[i + 3] !== 0) {
          x = (i / 4) % image.width;
          y = ~~(i / 4 / image.width);

          if (bound.top === -1) {
            bound.top = y;
          }

          if (bound.left === -1) {
            bound.left = x;
          } else if (x < bound.left) {
            bound.left = x;
          }

          if (bound.right === -1) {
            bound.right = x;
          } else if (bound.right < x) {
            bound.right = x;
          }

          if (bound.bottom === -1) {
            bound.bottom = y;
          } else if (bound.bottom < y) {
            bound.bottom = y;
          }
        }
      }

      // Calculate the height and width of the content
      const trimHeight = bound.bottom - bound.top;
      const trimWidth = bound.right - bound.left;
      const trimmed = copy.getImageData(
        bound.left,
        bound.top,
        trimWidth,
        trimHeight
      );

      copy.canvas.width = trimWidth;
      copy.canvas.height = trimHeight;
      copy.putImageData(trimmed, 0, 0);

      resolve({
        data: copy.canvas.toDataURL(),
        width: trimWidth,
        height: trimHeight
      });
    };

    // Return trimmed canvas
    // return copy.canvas
  });
}

export { getRotation, trimImage, stringContainsArrayElement };
